(function () {
  var SvgChartMapping = MST.SvgChartMapping;
  var SvgChartDrawUtil = MST.SvgChartDrawUtil;
  var SvgChartUtil = MST.SvgChartUtil;
  var SvgChartTechnical = MST.SvgChartTechnical;
  var SvgChartCache = MST.SvgChartCache;

  var SvgChartActionView = function (chart, viewDiv) {
    this.chart = chart;
    this.mapping = new SvgChartMapping();
    this.mapping.panel = chart.chartConfig.actionView.panel;

    if (chart.chartConfig.controller.showController) {
      this.mapping.offset = chart.chartConfig.controller.layout.height;
    } else {
      this.mapping.offset = 0;
    }
    this.mapping.offset = 42;

    this.actionDiv = document.createElement("div");
    viewDiv.appendChild(this.actionDiv);

    this.actionDiv.style.position = "absolute";
    this.actionDiv.style.width = "100%";
    this.actionDiv.style.height = "100%";
    this.actionDiv.style.zIndex = 5;
    this.actionDiv.className = "SvgChartActionView";

    if (this.chart.chartConfig.type != "PC") {
      this.actionDiv.style.zIndex = 8;
    }

    this.actionCanvasDiv = document.createElement("div");
    viewDiv.appendChild(this.actionCanvasDiv);

    this.actionCanvasDiv.style.position = "absolute";
    this.actionCanvasDiv.style.width = "100%";
    this.actionCanvasDiv.style.height = "100%";
    this.actionCanvasDiv.style.zIndex = 4;

    this.actionCanvasDiv1 = document.createElement("div");
    viewDiv.appendChild(this.actionCanvasDiv1);

    this.actionCanvasDiv1.style.position = "absolute";
    this.actionCanvasDiv1.style.width = "100%";
    this.actionCanvasDiv1.style.height = "100%";
    this.actionCanvasDiv1.style.zIndex = 4;

    this.dataDiv = document.createElement("div");
    viewDiv.appendChild(this.dataDiv);
    this.dataDiv.className = "SvgChartViewData";
    this.dataDiv.style.position = "absolute";
    this.dataDiv.style.zIndex = 100;
    this.dataDiv.style.visibility = "hidden";

    this.xAxisDiv = document.createElement("div");
    viewDiv.appendChild(this.xAxisDiv);
    this.xAxisDiv.className = "xAxisDiv";
    this.xAxisDiv.style.position = "absolute";
    this.xAxisDiv.style.zIndex = 4;
    this.xAxisDiv.style.visibility = "hidden";

    this.yAxisDiv = document.createElement("div");
    viewDiv.appendChild(this.yAxisDiv);
    this.yAxisDiv.className = "yAxisDiv";
    this.yAxisDiv.style.position = "absolute";
    this.yAxisDiv.style.zIndex = 4;
    this.yAxisDiv.style.visibility = "hidden";

    this.actionCanvas = SvgChartDrawUtil.createCanvas(
      this.actionCanvasDiv,
      this.chart.chartWidth,
      300
    );
    this.actionCanvas1 = SvgChartDrawUtil.createCanvas(
      this.actionCanvasDiv1,
      this.chart.chartWidth,
      300
    );

    if (this.chart.chartConfig.actionView.active) {
      var util = new SvgChartUtil();
      util.attachTouchEventOld(this, this.actionDiv);
    }
  };

  SvgChartActionView.prototype.chart = null;
  SvgChartActionView.prototype.mapping = null;
  SvgChartActionView.prototype.actionDiv = null;
  SvgChartActionView.prototype.actionCanvasDiv = null;
  SvgChartActionView.prototype.actionCanvas = null;
  SvgChartActionView.prototype.actionCanvasDiv1 = null;
  SvgChartActionView.prototype.actionCanvas1 = null;
  SvgChartActionView.prototype.panelActionStatus = null;
  SvgChartActionView.prototype.prePanelActionStatus = null;
  SvgChartActionView.prototype.drawAreaHeight = null;
  SvgChartActionView.prototype.index = null;
  SvgChartActionView.prototype.dataDiv = null;
  SvgChartActionView.prototype.dataList = null;

  SvgChartActionView.prototype.onPinchStart = function () {
    if (this.mapping.status != SvgChartTechnical.DATA_STATUS_OK) {
      return true;
    }

    this.panelActionStatus = null;
    this.drawPanelAction();

    this.dataStartIndex = this.chart.viewList[0].mapping.dataStartIndex;
    this.dataLength = this.chart.viewList[0].mapping.dataLength;
    this.middle = this.dataStartIndex + this.dataLength / 2;
    this.maxLength = this.chart.mainTechnical.data.length;
  };

  SvgChartActionView.prototype.onZoom = function (scale) {
    if (
      this.mapping.status != SvgChartTechnical.DATA_STATUS_OK ||
      this.dataLength == null
    ) {
      return true;
    }

    var dataLength = Math.round(this.dataLength / scale);
    dataLength = Math.min(
      Math.max(dataLength, this.chart.minPageLength),
      this.maxLength
    );
    var dataStartIndex = Math.round(this.middle - (dataLength * scale) / 2);
    dataStartIndex = Math.min(
      Math.max(dataStartIndex, 0),
      this.maxLength - dataLength
    );

    this.chart.setDataRange(dataStartIndex, dataLength);
  };

  SvgChartActionView.prototype.onPanStart = function () {
    if (this.mapping.status != SvgChartTechnical.DATA_STATUS_OK) {
      return true;
    }

    this.panelActionStatus = null;
    this.drawPanelAction();

    this.dataStartIndex = this.chart.viewList[0].mapping.dataStartIndex;
    this.dataLength = this.chart.viewList[0].mapping.dataLength;
    this.maxLength = this.chart.mainTechnical.data.length;
    //	this.panStartX = this.chart.viewList[0].mapping.transformIndex(this.dataStartIndex);
  };

  SvgChartActionView.prototype.onMove = function (x) {
    if (
      this.mapping.status != SvgChartTechnical.DATA_STATUS_OK ||
      this.dataLength == null
    ) {
      return true;
    }

    var x0 = this.chart.viewList[0].mapping.transformIndex(this.dataStartIndex);
    var dataStartIndex = Math.round(
      this.chart.viewList[0].mapping.unTransformIndex(x0 - x)
    );

    dataStartIndex = Math.min(
      Math.max(dataStartIndex, 0),
      this.maxLength - this.dataLength
    );

    this.chart.setDataRange(dataStartIndex, this.dataLength);
  };

  SvgChartActionView.prototype.onTap = function (cursor) {
    if (this.mapping.status != SvgChartTechnical.DATA_STATUS_OK) {
      return true;
    }

    this.panelActionStatus = cursor;
    this.drawPanelAction();
  };

  SvgChartActionView.prototype.onTouchEvent = function (
    target,
    pharse,
    cursorCoords
  ) {
    if (this.mapping.status != SvgChartTechnical.DATA_STATUS_OK) {
      return true;
    }

    return this.onPanelTouchEvent(pharse, cursorCoords);
  };

  SvgChartActionView.prototype.hitTestPanel = function (x, y) {
    return "inside";
  };

  SvgChartActionView.prototype.onPanelTouchEvent = function (
    pharse,
    cursorCoords
  ) {
    this.touchCount++;
    if (this.touchCount < 20) return;

    var preventDefault = false;

    var x, y, ax, ay;

    if (cursorCoords != null) {
      x = cursorCoords.x;
      y = cursorCoords.y;
      ax = cursorCoords.ax;
      ay = cursorCoords.ay;
    }

    if (pharse == "touchstart") {
      var hittest = this.hitTestPanel(x, y);

      if (hittest != null) {
        // preventDefault = true;

        this.panelActionStatus = { x: x, y: y, ax: ax, ay: ay };
        // this.dataDiv.style.visibility = "visible";
        this.onClick();
      }
    } else if (pharse == "touchmove") {
      // if(this.panelActionStatus != null) {
      preventDefault = true;

      this.panelActionStatus = { x: x, y: y, ax: ax, ay: ay };
      this.drawPanelAction();
      // }
    } else if (pharse == "touchout") {
      if (this.panelActionStatus != null) {
        // preventDefault = true;

        this.panelActionStatus = null;
        this.drawPanelAction();
        this.dataDiv.style.visibility = "hidden";
        this.xAxisDiv.style.visibility = "hidden";
        this.yAxisDiv.style.visibility = "hidden";
        this.index = -1;
      }
    }

    return !preventDefault;
    // return true;
  };

  SvgChartActionView.prototype.resetColor = function () {
    for (var i = 0; i < this.chart.viewList.length; i++) {
      for (var t = 0; t < this.chart.viewList[i].technicalList.length; t++) {
        var technical = this.chart.viewList[i].technicalList[t];
        let elements = technical.elements;
        if (elements != null) {
          let element = elements[this.index];
          if (element != null) {
            if (
              technical.dataColor != null &&
              technical.dataColorSelect != null
            ) {
              for (var d = 0; d < technical.dataColor.length; d++) {
                if (
                  SvgChartDrawUtil.getAttr(element, "fill") ==
                  technical.dataColorSelect[d]
                ) {
                  SvgChartDrawUtil.setAttr(
                    element,
                    "fill",
                    technical.dataColor[d]
                  );
                }
              }
            }
          }
        }
      }
    }
  };

  SvgChartActionView.prototype.onClick = function () {
    this.chart.onclick();
    var mapping = this.chart.viewList[0].mapping;
    if (
      this.panelActionStatus != null &&
      this.chart.mainTechnical.data != null
    ) {
      var index = Math.max(
        mapping.dataStartIndex,
        Math.min(
          mapping.dataStartIndex + mapping.dataLength - 1,
          Math.round(mapping.unTransformIndex(this.panelActionStatus.x))
        )
      );
    }
    if (
      this.panelActionStatus != null &&
      this.chart.mainTechnical.data != null
    ) {
      var ax = this.panelActionStatus.ax;
      var ay = this.panelActionStatus.ay;

      var x = mapping.transformIndex(index) + 0.5;

      if (this.chart.mainTechnical.data[index] == null) {
        return;
      }
      var v = this.chart.mainTechnical.data[index]["close"];
      var start = Math.max(0, mapping.dataStartIndex);
      var startv = this.chart.mainTechnical.data[start]["close"];

      if (mapping.benchmark == true) {
        v = (v / startv - 1) * 100;
      }
      var y = mapping.transformValue(v, this.chart.mainTechnical.vAxis) + 0.5;

      var data = this.chart.mainTechnical.data[index];

      var date;

      if (data != null) {
        date = this.chart.detailTimeFormat(data.date);
      }
    }
  };

  SvgChartActionView.prototype.drawPanelAction = function () {
    var mapping = this.chart.viewList[0].mapping;

    if (
      this.panelActionStatus == null ||
      this.panelActionStatus.x >= this.chart.viewDiv.clientWidth - 55 ||
      (this.panelActionStatus.y >= mapping.drawAreaHeight && false)
    ) {
      this.dataDiv.style.visibility = "hidden";
      this.xAxisDiv.style.visibility = "hidden";
      this.yAxisDiv.style.visibility = "hidden";
      var context = this.actionCanvas;
      SvgChartDrawUtil.clear(context);
      var context_point = this.actionCanvas1;
      SvgChartDrawUtil.clear(context_point);
      return;
    }
    // var mapping = this.chart.viewList[this.chart.viewList.length - 1].mapping;
    var paddingBottom = 5;
    if (this.chart.viewList[this.chart.viewList.length - 1].mapping) {
      paddingBottom =
        this.chart.viewList[this.chart.viewList.length - 1].mapping
          .paddingBottom;
    }
    if (
      this.panelActionStatus != null &&
      this.chart.mainTechnical.data != null
    ) {
      var index = Math.max(
        mapping.dataStartIndex,
        Math.min(
          mapping.dataStartIndex + mapping.dataLength - 1,
          Math.round(mapping.unTransformIndex(this.panelActionStatus.x))
        )
      );
    }

    var util = new SvgChartUtil();

    // Get panel context
    var context = this.actionCanvas;
    SvgChartDrawUtil.clear(context);
    var context_point = this.actionCanvas1;
    SvgChartDrawUtil.clear(context_point);
    this.resetColor();

    if (
      this.panelActionStatus != null &&
      this.chart.mainTechnical.data != null
    ) {
      if (mapping.benchmark == false) {
        var cacheData = SvgChartCache.load(
          this.chart.mainTechnical.dataLoadUrl
        );

        if (cacheData != null) {
          // var target = [];
          var target = {};

          for (var i = cacheData.data.length - 1; i >= 0; i--) {
            // target.push(cacheData.data[i]);
            target[cacheData.data[i][0]] = cacheData.data[i][2];
          }

          var dividendSum = 0;

          for (
            var i = mapping.dataStartIndex;
            i < mapping.dataStartIndex + mapping.dataLength;
            i++
          ) {
            if (this.chart.mainTechnical.data[i] == null) continue;

            if (
              target[
                new Date(this.chart.mainTechnical.data[i].date).getTime()
              ] != null
            ) {
              dividendSum += Number(
                target[
                  new Date(this.chart.mainTechnical.data[i].date).getTime()
                ]
              );
            }

            if (this.chart.mainTechnical.data[i].close != null) {
              this.chart.mainTechnical.data[i].dividend =
                this.chart.mainTechnical.data[i].close + dividendSum;
            }
          }
        }
      }

      var x0 = mapping.paddingLeft;
      var x1 = mapping.drawAreaWidth - mapping.paddingRight;

      var y0 = mapping.paddingTop + 0.5;
      var y1;
      if (mapping.benchmark) {
        y1 = mapping.drawAreaHeight - mapping.paddingBottom - 0.5;
      } else {
        y1 = this.drawAreaHeight - paddingBottom - 0.5;
      }

      // Draw cross
      var x = mapping.transformIndex(index) + 0.5;
      // var y = Math.max(y0, Math.min(y1 , this.panelActionStatus.y)) + 0.5;
      var ax = this.panelActionStatus.ax;
      var ay = this.panelActionStatus.ay;

      if (this.chart.mainTechnical.data[index] == null) {
        return;
      }
      var v = this.chart.mainTechnical.data[index]["close"];
      if (v == null) return;

      var start = Math.max(0, mapping.dataStartIndex);
      var end = mapping.dataStartIndex + mapping.dataLength;
      for (var k = start; k < end; k++) {
        if (
          this.chart.mainTechnical.data[k] &&
          this.chart.mainTechnical.data[k]["close"]
        )
          break;
      }
      var startv = this.chart.mainTechnical.data[k]["close"];

      if (mapping.benchmark == true) {
        if (!isNaN(startv)) v = (v / startv - 1) * 100;
        else v = null;
      }
      var y = mapping.transformValue(v, this.chart.mainTechnical.vAxis) + 0.5;
      var offset = 0;

      // dataList
      var data = this.chart.mainTechnical.data[index];

      var date;
      let date_xAxis;
      if (data != null) {
        date = this.chart.detailTimeFormat(data.date);
        date_xAxis = this.chart.timeFormat(data.date);
      }

      this.actionDiv.style.cursor = "";
      this.dataDiv.className = "SvgChartViewData";
      this.dataDiv.style.backgroundColor = "#FFFFFF";
      SvgChartDrawUtil.line(
        context,
        x,
        y0,
        x,
        y1,
        this.mapping.panel.crossColor
      );
      SvgChartDrawUtil.line(
        context,
        x0,
        y,
        x1 + 10,
        y,
        this.mapping.panel.crossColor
      );

      var txtPrefix = "<span>" + date + "</span>";
      var txtElements = [];

      for (var i = 0; i < this.chart.viewList.length; i++) {
        var mapping = this.chart.viewList[i].mapping;

        for (var t = 0; t < this.chart.viewList[i].technicalList.length; t++) {
          var technical = this.chart.viewList[i].technicalList[t];

          if (technical.type == "sub" && this.chart.mainMapping.benchmark) {
            continue;
          }

          if (mapping.benchmark) {
            if (t > 0 && technical.benchmarkShow == false) {
              continue;
            }
          }

          if (technical.type == "dummy") continue;
          //				if (mapping.benchmark && technical.dataLoadType != SvgChartTechnical.DATA_LOAD_TYPE_URL) continue;
          if (
            technical.view.chart.showFund &&
            mapping.benchmark &&
            technical == technical.view.chart.mainTechnical
          )
            continue;

          let elements = technical.elements;
          if (elements != null) {
            let element = elements[index];
            if (element != null) {
              if (
                technical.dataColor != null &&
                technical.dataColorSelect != null
              ) {
                for (var d = 0; d < technical.dataColor.length; d++) {
                  if (
                    SvgChartDrawUtil.getAttr(element, "fill") ==
                    technical.dataColor[d]
                  ) {
                    SvgChartDrawUtil.setAttr(
                      element,
                      "fill",
                      technical.dataColorSelect[d]
                    );
                  }
                }
              }
            }
          }

          var labels = technical.labels;
          var dataColor = technical.dataColor;
          if (i == 0 && mapping.benchmark == true) {
            labels = [{ label: technical.code, data: technical.dataLoadName }];
          }

          var type = "price2";
          if (technical.name == "volume") {
            type = "volume";
          } else if (technical.code == "JPY=X") {
            type = "price2";
          } else if (
            technical.code != null &&
            technical.code.substring(0, 1) != "."
          ) {
            type = "price";
          } else if (
            technical.code == null &&
            this.chart.mainTechnical.code.substring(0, 1) != "."
          ) {
            type = "price";
          }

          // var br = "&nbsp;";
          var br = "";
          if (labels) {
            for (var j = 0; j < labels.length; j++) {
              var txt = "";
              var label;
  
              if (
                i > 0 ||
                t > 0 ||
                ((technical.name == "candle" ||
                  technical.name == "portfolioLine" ||
                  technical.name == "portfolioMountain") &&
                  mapping.benchmark == false)
              ) {
                label = this.chart.getLabel(labels[j].label);
  
                // label = labels[j].label;
              } else {
                if (
                  mapping.benchmark == false &&
                  technical.view.technicalList.length > 1
                ) {
                  label = "基準価額";
                } else {
                  label = this.chart.name;
                }
              }
              if (technical.name == "fundLine" && mapping.benchmark) {
                label = this.chart.name;
              }
  
              if (technical.params != null && technical.labelShowParam) {
                label = label + "(" + technical.params[j] + ")";
              }
  
              if (technical.name == "candle" && mapping.benchmark == false) {
                txt =
                  txt +
                  br +
                  "<div class='mst_tooltip'><span>●</span>&nbsp;<span>" +
                  label +
                  ": ";
              } else {
                txt =
                  txt +
                  br +
                  "<div class='mst_tooltip'><span style='color:" +
                  dataColor[j] +
                  "'>●</span>&nbsp;";
                txt = txt + "<span>" + label + ": ";
              }
  
              var showv;
              if (technical.dataLoadType == SvgChartTechnical.DATA_ANALYSIS) {
                v = technical.data[labels[j].data][index];
                startv = technical.data[technical.labels[j].data][start];
              } else if (
                technical.dataLoadType ==
                SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN
              ) {
                v = data[labels[j].data];
  
                for (var k = start; k < end; k++) {
                  if (
                    this.chart.mainTechnical.data[k] &&
                    this.chart.mainTechnical.data[k][labels[j].data]
                  )
                    break;
                }
  
                startv = this.chart.mainTechnical.data[k][labels[j].data];
              } else {
                if (technical.data[index] == null) {
                  txt = txt + "</span></div>";
                  continue;
                }
  
                v = technical.data[index][labels[j].data];
                if (v == null) continue;
  
                for (var k = start; k < end; k++) {
                  if (technical.data[k] && technical.data[k][labels[j].data])
                    break;
                }
  
                startv = technical.data[k][labels[j].data];
              }
  
              showv = MST.SvgChart.numberFormatFunc(v, type);
              if (
                technical.name == "portfolioLine" ||
                technical.name == "portfolioMountain"
              ) {
                if (j == 0) {
                  showv = showv + this.chart.symbol;
                } else {
                  showv = showv + "%";
                }
              }
  
              if (i == 0 && mapping.benchmark == true) {
                if (!isNaN(startv) && startv != null) {
                  var percentv = (v / startv - 1) * 100;
                  showv = Math.round(percentv * 100) / 100 + "%(" + showv + ")";
                  v = percentv;
                } else {
                  for (var k = start; k < end; k++) {
                    if (
                      technical.data != null &&
                      technical.data[k] &&
                      technical.data[k][labels[j].data]
                    ) {
                      break;
                    }
                  }
                  if (k != end && index >= k) {
                    var sv = technical.data[k][labels[j].data];
                    var percentv = (v / sv - 1) * 100;
                    showv = Math.round(percentv * 100) / 100 + "%(" + showv + ")";
                    v = percentv;
                  } else {
                    v = null;
                  }
                }
              }
  
              if (v != null && v != undefined) {
                txt = txt + "<b>" + showv + "</b></span></div>";
  
                if (technical.projectorType == "line" || mapping.benchmark) {
                  var y = mapping.transformValue(v, technical.vAxis) + 0.5;
  
                  for (var n = 0; n < i; n++) {
                    y += this.chart.viewList[n].mapping.drawAreaHeight;
                  }
  
                  SvgChartDrawUtil.drawPoint(
                    context_point,
                    x,
                    y,
                    dataColor[j],
                    4
                  );
                }
              } else {
                txt = txt + "</span></div>";
              }
  
              txtElements.push([txt, percentv]);
  
              var yAxisV;
              // if (i == 0 && t == 0 && j == 0) {
              if (i == 0 && t == 0 && j == labels.length - 1) {
                if (mapping.benchmark == true) {
                  yAxisV = Math.round(percentv * 100) / 100 + "%";
                } else {
                  yAxisV = MST.SvgChart.numberFormatFunc(v, type);
                }
  
                this.yAxisDiv.innerHTML = "<i></i>" + yAxisV;
                this.yAxisDiv.style.top =
                  y + offset - this.yAxisDiv.clientHeight / 2 + "px";
                this.yAxisDiv.style.left =
                  mapping.drawAreaWidth - this.yAxisDiv.clientWidth + "px";
                this.yAxisDiv.style.visibility = "visible";
              }
            }
          }
        }
      }

      this.xAxisDiv.innerHTML = date_xAxis;
      this.xAxisDiv.style.top =
        this.chart.viewList[0].mapping.drawAreaHeight +
        offset -
        this.xAxisDiv.clientHeight +
        "px";
      this.xAxisDiv.style.left = x - this.xAxisDiv.clientWidth / 2 + "px";
      this.xAxisDiv.style.visibility = "visible";

      var dataHTML = txtPrefix;

      if (this.chart.viewList[0].mapping.benchmark) {
        for (var i = 0; i < txtElements.length; i++) {
          for (var j = i + 1; j < txtElements.length; j++) {
            if (Number(txtElements[i][1]) < Number(txtElements[j][1])) {
              var temp = txtElements[i];
              txtElements[i] = txtElements[j];
              txtElements[j] = temp;
            }
          }
        }
      }

      for (var i = 0; i < txtElements.length; i++) {
        dataHTML += txtElements[i][0];
      }

      this.dataDiv.innerHTML = dataHTML;

      var w = this.dataDiv.clientWidth;
      var h = this.dataDiv.clientHeight;

      var t = ay + offset - 40 - h;
      if (t < offset + 10) t = ay + offset + 40;
      this.dataDiv.style.top = t + "px";

      if (x < (x1 - x0) / 2) {
        this.dataDiv.style.left = ax + 40 + "px";
      } else {
        this.dataDiv.style.left = Math.max(ax - 40 - w, 0) + "px";
      }
      this.dataDiv.style.visibility = "visible";
    }

    this.index = index;
  };

  MST.SvgChartActionView = SvgChartActionView;
})();
